import members from 'config/api/members/members';

const coworkerParamsGetter = (query: any) => [members.search({ limit: 100, search: query })];

export default coworkerParamsGetter;
